<template>
	<div class="container__radiobuttons">
		<div style="display: flex; gap: 0.25rem; align-items: center">
			<p style="margin: 0">{{ label }}</p>
			<slot />
		</div>
		<div
			v-for="(option, index) in options"
			:key="option.label + index"
			:class="[
				'container__radiobuttons__option',
				color,
				{ 'container__radiobuttons__option--disabled': disabled || option.disabled },
			]"
		>
			<input
				:id="groupName + index"
				type="radio"
				:checked="option.value === value"
				:name="groupName"
				:value="option.value"
				:disabled="disabled || option.disabled"
				@click="changeValue($event)"
			/>
			<label :for="groupName + index">{{ option.label }}</label>
			<span
				v-if="option.badge"
				class="container__radiobuttons__option__badge"
				:aria-label="option.badgeTooltip || null"
			>
				{{ option.badge }}
				<span
					v-if="option.badgeTooltip"
					class="container__radiobuttons__option__badge__tooltip"
					role="tooltip"
					>{{ option.badgeTooltip }}</span
				>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Nome do grupo de radio button
		 */
		groupName: String,
		/**
		 * label acima dos radio buttons
		 */
		label: String,
		/**
		 * Opções para os radios buttons
		 */
		options: Array,
		/**
		 * Valor que sera feito o bind
		 */
		value: [String, Number, Boolean],
		/**
		 *
		 */
		disabled: { type: Boolean },
		clickListener: Function,
		color: {
			type: String,
			default: 'trv-default',
			validator: (value) => {
				return ['trv-default', 'trv-primary'].indexOf(value) !== -1
			},
		},
	},
	methods: {
		/**
		 * Evento para fazer o bind
		 */
		changeValue(event) {
			const value = event.target.value

			//verifica se valores são booleanos, faz conversão para booleano, evita emitir uma string 'false' ou 'true'
			if (value === 'false' || value === 'true') {
				this.$emit('input', JSON.parse(event.target.value))
			} else {
				this.$emit('input', event.target.value)
			}

			if (this.clickListener) this.clickListener()
		},
	},
}
</script>

<style>
.container__radiobuttons {
	font-size: 0.75rem;
	color: rgb(var(--color-primary));
	user-select: none;
}

.container__radiobuttons > p {
	margin-bottom: 0.1rem;
}

.container__radiobuttons__option {
	display: flex;
	align-items: center;
}

.container__radiobuttons__option > input {
	margin-right: 0.5rem;
	appearance: none;
	height: 15px;
	width: 15px;
	border-radius: 50%;
	position: relative;
	border: 2px solid #a9a9a9;
	outline: none;
}

.container__radiobuttons__option > input::before {
	position: absolute;
	content: '';
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	height: 0;
	width: 0;
	border-radius: 50%;
}

.container__radiobuttons__option.trv-default > input::before {
	background-color: rgb(var(--color-default));
}

.container__radiobuttons__option.trv-primary > input::before {
	background-color: rgb(var(--color-primary));
}

.container__radiobuttons__option > input:checked::before {
	height: 8px;
	width: 8px;
	transition: all 0.2s linear;
}

.container__radiobuttons__option > input:checked + label {
	font-weight: 700;
}

/**
 * A opacidade fica no input e no label, nao no container: uma badge de upgrade e o seu
 * tooltip sao descendentes e herdariam o 0.5, deixando o texto ilegivel -- opacidade de
 * ancestral nao pode ser desfeita pelo filho. O resultado visual para as opcoes sem badge
 * e o mesmo de antes, ja que input e label eram os unicos filhos.
 */
.container__radiobuttons__option--disabled > input,
.container__radiobuttons__option--disabled > label {
	opacity: 0.5;
	cursor: not-allowed;
}

.container__radiobuttons__option__badge {
	position: relative;
	margin-left: 0.4rem;
	padding: 0 0.5rem;
	background-color: var(--color-green);
	color: white;
	font-size: 9px;
	line-height: 1.5;
	height: fit-content;
	border-radius: 5px;
	text-transform: capitalize;
	cursor: help;
}

.container__radiobuttons__option__badge__tooltip {
	visibility: hidden;
	opacity: 0;
	position: absolute;
	bottom: calc(100% + 0.4rem);
	/* Ancorado a esquerda da badge em vez de centrado: centrar joga metade da largura
	   para fora da borda esquerda do formulario, porque o radio fica encostado nela. */
	left: 0;
	width: max-content;
	max-width: 14rem;
	padding: 0.4rem 0.6rem;
	border-radius: 5px;
	background-color: rgb(var(--color-primary));
	color: white;
	font-size: 0.7rem;
	line-height: 1.3;
	font-weight: normal;
	text-transform: none;
	white-space: normal;
	text-align: left;
	z-index: 100;
	transition:
		visibility 0s,
		opacity 0.2s;
}

.container__radiobuttons__option__badge:hover
	> .container__radiobuttons__option__badge__tooltip {
	visibility: visible;
	opacity: 1;
}
</style>
